import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  outerWrapper: {
    display: 'flex',
    gap: '32px',
    width: '100%',
    alignItems: 'stretch',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
  },
  metaDividerPipe: {
    marginInline: '4px',
  },
  contentColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    flex: 1,
    minWidth: 0,
  },
  chipsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  chip: {
    borderRadius: '4px',
    backgroundColor: 'primary.main',
    color: 'common.white',
    height: 'auto',
    padding: '6px 12px',
    '& .MuiChip-label': {
      padding: 0,
    },
  },
  heading: {
    maxWidth: '824px',
  },
  description: {
    maxWidth: '742px',
  },
  authorMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: {
      xs: '8px',
      md: '12px',
    },
  },
  authorImage: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
  },
  authorName: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  metaDivider: {
    color: 'text.secondary',
  },
  shareRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '16px',
  },
  shareIcons: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  shareIconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'text.primary',
  },
  featureImage: {
    aspectRatio: '480/271',
    maxWidth: '480px',
    maxHeight: '271px',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: { md: '32px' },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
